import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";

function AppInstallBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [storeLink, setStoreLink] = useState("");

  const checkAndShowBanner = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const hideUntil = localStorage.getItem("hideAppInstallBannerUntil");

    if (hideUntil && Date.now() < parseInt(hideUntil, 10)) {
      const timeRemaining = parseInt(hideUntil, 10) - Date.now();
      setTimeout(checkAndShowBanner, timeRemaining);
      return;
    }

    if (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)) {
      setShowBanner(true);
      setStoreLink("https://onelink.to/uqfefy");
      document.body.classList.add("has-app-banner");
    }
  };

  useEffect(() => {
    checkAndShowBanner();
    
    // Cleanup on unmount
    return () => {
      document.body.classList.remove("has-app-banner");
    };
  }, []);

  const handleClose = () => {
    setShowBanner(false);
    document.body.classList.remove("has-app-banner");
    
    const hideDuration = 5 * 60 * 1000;
    const hideUntil = Date.now() + hideDuration;
    localStorage.setItem("hideAppInstallBannerUntil", hideUntil.toString());

    setTimeout(checkAndShowBanner, hideDuration);
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      background: "#fff",
      boxShadow: "0 -2px 5px rgba(0,0,0,0.2)",
      padding: "15px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      zIndex: 999
    }}>
      <div>
        <h4 style={{ margin: 0, color: "#24366b" }}>Get our App</h4>
        <p style={{ margin: 0, fontSize: "14px", color: "#24366b" }}>
          Download for a better experience
        </p>
      </div>
      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        <a
          href={storeLink}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            background: "#4a85ff",
            color: "#fff",
            padding: "8px 16px",
            borderRadius: "5px",
            textDecoration: "none"
          }}
        >
          Download
        </a>
        <button 
          onClick={handleClose}
          style={{
            background: "transparent",
            border: "none",
            color: "#6c757d",
            cursor: "pointer",
            padding: "5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
          aria-label="Close"
        >
          <FaTimes size={18} />
        </button>
      </div>
    </div>
  );
}

export default AppInstallBanner;